import React, { useEffect, useState } from "react";
import { List, Button, Typography, Modal, Flex } from "antd";
import { toast } from "react-toastify";
import { customLogger } from "../../../../utils/Logger";
import CustomLoader from "../../../common/UI/Loader";
import ENDPOINTS from "../../../../services/endpoint";
import apiInstance from "../../../../services/apiService";
import "./index.scss";

const { Title, Text } = Typography;

interface CancelledNumbersListProps {
  refreshSubbedAddons: any;
  loading: boolean;
  setLoading: any;
  getCancelledNumbers: any;
  cancelledNumbers: any;
}

interface CancelledNumber {
  _id: string;
  cost: string;
  currency: string;
  phoneNumber: string;
  remainingDays: number;
}

const CancelledNumbersList: React.FC<CancelledNumbersListProps> = ({
  refreshSubbedAddons,
  loading,
  setLoading,
  getCancelledNumbers,
  cancelledNumbers,
}) => {
  const [paymentGatewayModalOpen, setPaymentGatewayModalOpen] = useState(false);
  const [paymentGatewayDetails, setPaymentGatewayDetails] = useState<any>(null);

  const resubNumber = async (item: CancelledNumber) => {
    const url = ENDPOINTS.RESUB_PHONE + item._id;

    setLoading(true);
    try {
      const response = await apiInstance.get(url);
      const message = response.data.message;
      toast.success(message || "Reassigned Succesfully");
      getCancelledNumbers();
      refreshSubbedAddons();
    } catch (error: any) {
      customLogger(error);
      if (error.hostedpageDetails) {
        toast.info("Please update your payment gateway first");
        setPaymentGatewayDetails(error.hostedpageDetails);
        setPaymentGatewayModalOpen(true);
      } else {
        toast.error(error.message || "There was an error. Please try again");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCancelledNumbers();
  }, [getCancelledNumbers]);

  return (
    <>
      <List
        className="cancelled-number-list"
        loading={{
          spinning: loading,
          indicator: (
            <Flex className="w-full h-full" justify="center" align="center">
              <CustomLoader />
            </Flex>
          ),
        }}
        dataSource={cancelledNumbers || []}
        renderItem={(item: CancelledNumber) => (
          <List.Item className="addon-item">
            <div>
              <Title level={5} className="addon-title">
                {item.phoneNumber}{" "}
                <span
                  style={{
                    color: "red",
                    textTransform: "capitalize",
                    fontSize: "14px",
                  }}
                >
                  Cancelled
                </span>
              </Title>
              <Text className="addon-description">
                {item.currency} {item.cost} Monthly
              </Text>
              <br />
              <Text className="addon-description">
                {item.remainingDays} days remaining to subscribe
              </Text>
            </div>
            <Button
              onClick={() => resubNumber(item)}
              type="text"
              className="addon-button"
            >
              Resubscribe
            </Button>
          </List.Item>
        )}
      />

      <Modal
        open={paymentGatewayModalOpen}
        onCancel={() => setPaymentGatewayModalOpen(false)}
        footer={null}
      >
        <iframe
          title="payment"
          src={paymentGatewayDetails?.url}
          width="100%"
          height="660px"
          style={{ border: "none" }}
          allowFullScreen
        />
      </Modal>
    </>
  );
};

export default CancelledNumbersList;
